import React from 'react';
import PropTypes from 'prop-types';
import BlankTemplate from 'components/Templates/BlankTemplate';
import List from 'components/Organisms/MyPay/PastEmployerTaxes/List';

const ListTemplate = ({
  loading,
  rows,
  columns,
  count,
  selectedItems,
  rowsPerPage,
  totalRecordCount,
  loadNextPageData,
  handleSort,
  handleRowClick,
  page,
  sortDirection,
  sortBy,
  handleSelect,
  onSelect,
  onSelectAll,
  showPagination,
  onPageChange,
  handleFilter,
  handleAdd,
  keyColumn,
  showActionList,
  roleBasedMenu,
  checkboxColor,
  pageHeading,
  showRowSelector,
  showActions,
  showAddNew,
  filterFields,
  actionOptions,
  handleFiltersClear,
  showFilter,
  onSortChange,
}) => {
  return (
    <BlankTemplate pageHeading={pageHeading} isBreadcrumb={false} padding="2rem 3rem">
      <List
        loading={loading}
        onSortChange={onSortChange}
        rows={rows}
        page={page}
        sortDirection={sortDirection}
        sortBy={sortBy}
        handleSelect={handleSelect}
        onSelect={onSelect}
        onSelectAll={onSelectAll}
        count={count}
        selectedItems={selectedItems}
        showPagination={showPagination}
        onPageChange={onPageChange}
        handleSort={handleSort}
        handleRowClick={handleRowClick}
        keyColumn={keyColumn}
        showActionList={showActionList}
        handleAdd={handleAdd}
        roleBasedMenu={roleBasedMenu}
        showRowSelector={showRowSelector}
        showAddNew={showAddNew}
        columns={columns}
        handleFilter={handleFilter}
        filterFields={filterFields}
        actionOptions={actionOptions}
        handleFiltersClear={handleFiltersClear}
        showFilter={showFilter}
        rowsPerPage={rowsPerPage}
        checkboxColor={checkboxColor}
        showActions={showActions}
        totalRecordCount={totalRecordCount}
        loadNextPageData={loadNextPageData}
      />
    </BlankTemplate>
  );
};

ListTemplate.defaultProps = {
  filterFields: [],
  loading: false,
  pageHeading: '',
  roleBasedMenu: () => {},
  checkboxColor: '',
  rows: [],
  columns: [],
  count: 10,
  selectedItems: [],
  handleFilter: () => {},
  handleSelect: () => {},
  onSelect: () => {},
  onSelectAll: () => {},
  sortBy: () => {},
  handleSort: () => {},
  handleRowClick: () => {},
  onPageChange: () => {},
  keyColumn: '',
  showPagination: false,
  rowsPerPage: '',
  loadNextPageData: '',
  showActionList: false,
  page: '',
  sortDirection: 'asc',
  totalRecordCount: 6,
  handleAdd: () => {},
  showRowSelector: false,
  showActions: false,
  showAddNew: false,
  actionOptions: [],
  handleFiltersClear: () => {},
  showFilter: false,
  onSortChange: () => {},
};

ListTemplate.propTypes = {
  filterFields: PropTypes.arrayOf,
  loading: PropTypes.bool,
  pageHeading: PropTypes.string,
  roleBasedMenu: PropTypes.func,
  checkboxColor: PropTypes.string,
  handleFilter: PropTypes.func,
  handleSelect: PropTypes.func,
  onSelect: PropTypes.func,
  count: PropTypes.number,
  selectedItems: PropTypes.arrayOf,
  showPagination: PropTypes.bool,
  onPageChange: PropTypes.func,
  onSelectAll: PropTypes.func,
  keyColumn: PropTypes.string,
  sortBy: PropTypes.func,
  handleSort: PropTypes.func,
  handleRowClick: PropTypes.func,
  rowsPerPage: PropTypes.number,
  totalRecordCount: PropTypes.number,
  loadNextPageData: PropTypes.number,
  page: PropTypes.number,
  showActionList: PropTypes.bool,
  sortDirection: PropTypes.string,
  rows: PropTypes.arrayOf,
  columns: PropTypes.arrayOf,
  handleAdd: PropTypes.func,
  showRowSelector: PropTypes.bool,
  showActions: PropTypes.bool,
  showAddNew: PropTypes.bool,
  actionOptions: PropTypes.arrayOf(
    PropTypes.shape({
      name: PropTypes.string,
      onClick: PropTypes.func,
    }),
  ),
  handleFiltersClear: PropTypes.func,
  showFilter: PropTypes.bool,
  onSortChange: PropTypes.func,
};

export default ListTemplate;
